"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

var _default = (0, _styles.makeStyles)(function (theme) {
  var _select;

  return {
    root: {},
    select: (_select = {
      height: theme.typography.pxToRem(22),
      lineHeight: 1.25,
      paddingTop: 13,
      paddingBottom: 13,
      // needed to override the mui one since it is more specific
      '&&': {
        paddingRight: theme.spacing(6)
      }
    }, (0, _defineProperty2.default)(_select, theme.breakpoints.up(1024), {
      height: '1.3333333em',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    }), (0, _defineProperty2.default)(_select, '&:focus', {
      backgroundColor: 'transparent'
    }), _select),
    icon: {
      color: theme.palette.denim[500],
      right: theme.spacing(2),
      '.Mui-disabled &': {
        color: theme.palette.neutral.mono
      }
    },
    disabled: {}
  };
}, {
  name: 'PdsSelect'
});

exports.default = _default;
